import { Row, Col } from 'react-bootstrap';
import { RiInformationLine } from '@remixicon/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function InfoBanner({ message = 'app.demoAlert', className = 'bg-pink', navigateTo = '/pricing' }) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Row className="mb-4" onClick={() => navigate(navigateTo)}>
            <Col xs={12}>
                <div className={`card-custom-content d-flex align-items-center gap-2 ${className}`}>
                    <RiInformationLine size={20} className="flex-shrink-0" />
                    <p className="card-text">{t(message)}</p>
                </div>
            </Col>
        </Row>
    );
}

export default InfoBanner;
